<template>
	<div v-for="option in options" :key="option[optionValue]" class="flex items-center mr-3 mb-2">
		<input
			type="radio"
			class="mr-1"
			:id="`${identifier}-${option[optionValue]}`"
			:name="name"
			:value="option[optionValue]"
			:modelValue="modelValue"
			:checked="option[optionValue] === modelValue"
			:disabled="disabled"
			@change="$emit('update:modelValue', option[optionValue])"
		/>
		<slot name="label" :option="option">
			<label :for="`${identifier}-${option[optionValue]}`">
				{{ option[optionLabel] }}
			</label>
		</slot>
	</div>
</template>

<script>
	export default {
		name: 'AppRadioGroup',
		props: {
			name: {},
			labelClass: {},
			modelValue: {},
			options: {},
			optionValue: {
				default: 'value',
			},
			optionLabel: {
				default: 'label',
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['update:modelValue'],
		computed: {
			identifier() {
				return Math.floor(Math.random() * 100000);
			},
		},
	};
</script>

<style lang="scss" scoped></style>
